import { get, off, onValue, ref, set } from 'firebase/database';
import { db } from '../pages/firebase';

export function observeProductLikes(productId, callback) {
  if (!productId) return () => {};

  const likeRef = ref(db, `productLikes/${productId}`);
  const listener = onValue(likeRef, (snapshot) => {
    const value = snapshot.val() || {};
    const likedBy = Object.keys(value || {}).filter((key) => Boolean(value[key]));
    callback({ count: likedBy.length, likedBy });
  });

  return () => off(likeRef, 'value', listener);
}

export async function toggleProductLike(productId, uid, liked) {
  if (!productId || !uid) throw new Error('Login required to like products.');

  const likeRef = ref(db, `productLikes/${productId}/${uid}`);
  await set(likeRef, liked ? true : null);

  return { liked };
}

export async function getUserLikedProducts(uid) {
  if (!uid) return [];

  const likesRef = ref(db, 'productLikes');
  const snapshot = await get(likesRef);
  const value = snapshot.val() || {};

  return Object.entries(value)
    .filter(([, users]) => Boolean(users?.[uid]))
    .map(([productId]) => productId);
}
